module.exports = __webpack_public_path__ + "static/media/background.760b9286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.png
// module id = 274
// module chunks = 0